module.exports = __webpack_public_path__ + "img/ot-pe_pendle.455ed087.png";